import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

export interface DeviceName {
  deviceName: string;
}

@Component({
  selector: 'ml-device-name-ui',
  templateUrl: './device-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule],
})
export class ManagedSettingsDeviceNameComponent {
  private readonly fb = inject(UntypedFormBuilder);
  private cd = inject(ChangeDetectorRef);

  readonly deviceName = output<DeviceName>();

  public readonly deviceNameForm = this.fb.group({
    deviceName: '',
  });

  onSubmit() {
    this.deviceName.emit(this.deviceNameForm.value);
  }
}
